<template>
  <div class="other_operate_modal" >
     
    <Modal    
          v-model="otherModal"
          :title="`【${houseDetail['房屋地址']}】业务操作`" 
            :width="screenWidth*0.8"
          @on-cancel="cancel">
          <div class="base-modal" v-if="otherModal">
       
            <div class="illustrate">  
              <Button type="primary" icon="ios-archive-outline" @click="changeIllustrate('修改附件')" :disabled="illustrate.name=='修改附件'">修改附件</Button>
              <Button type="primary" icon="ios-close-circle-outline" @click="changeIllustrate('合同终止')" :disabled="illustrate.name=='合同终止'">合同终止</Button>
              <Button type="primary" icon="ios-build-outline" @click="changeIllustrate('报修')" :disabled="illustrate.name=='报修'">报修</Button>
              <Button type="primary" icon="ios-paper-outline" @click="changeIllustrate('查看空置记录')" :disabled="illustrate.name=='查看空置记录'">查看空置记录</Button> 
              <Button type="primary" icon="ios-paper-outline" @click="changeIllustrate('查看出租记录')" :disabled="illustrate.name=='查看出租记录'">查看出租记录</Button> 
              <Button type="primary" icon="ios-lock-outline" @click="changeIllustrate('更改为自用房')" :disabled="illustrate.name=='更改为自用房'">更改为自用房</Button> 
              <Button type="primary" icon="ios-git-compare" @click="changeIllustrate('续约')" :disabled="illustrate.name=='续约'">续约</Button>  
              <Button type="primary" icon="ios-fastforward-outline" @click="changeIllustrate('更改为待出租')" :disabled="illustrate.name=='更改为待出租'">更改为待出租</Button>  
              <Button type="primary" icon="ios-create-outline" @click="changeIllustrate('补充信息')" :disabled="illustrate.name=='补充信息'">补充信息</Button>  
              <!-- 修改附件  合同终止  报修   查看记录   更改为自用房   续约    更改为待出组   补充信息-->
            </div>
            
            <Alert> 当前业务【{{ illustrate.name }}】 说明：{{ illustrate.content }}</Alert> 
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='修改附件'">  
              <Alert>产证信息</Alert>   
              
              <Upload :action="uploadUrl"  
              :headers="{ 'Authorization': 'Bearer ' +token }"
              accept=".jpg,.jpeg,.png,.pdf"
              :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '产证信息')" 
              :show-upload-list="true" 
              max-size="100*1024" >
            <Button type="info" style="margin-left:20px;">新增附件</Button>
              </Upload>
          <Table border :columns="fjColums" :data="czImgList" :max-height="400">

            <template #img="{ row, index } " >
                <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                  
                  <img style="width:200px;height:200px;" :src="row.img" alt="">
                </div>
                <div v-else>仅支持图片预览</div>
              </template> 
              <template #action="{ row, index } " >
                <div class="buttomGroup">
                  <div class="btn ck" @click="watchFile(row,'产证信息')">查看</div>
                  <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'产证信息')">下载</div> 
                  <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'产证信息')">删除</div>
                </div>
              </template> 
            </Table>

            <Alert>身份证信息</Alert>   
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '身份证信息')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="sfzImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'身份证信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'身份证信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'身份证信息')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>房屋托管合同信息</Alert>   

            <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋托管合同信息')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="fwtghtImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'房屋托管合同信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'房屋托管合同信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'房屋托管合同信息')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>房屋原貌</Alert>   
            <div style="width:100%;display: flex; gap:20px;">
              <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','客厅照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增客厅附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','厨房照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增厨房附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','卫生间照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增卫生间附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','卧室照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增卧室附件</Button>
                </Upload>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '房屋原貌','其他照片')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增其他房间附件</Button>
                </Upload>
              </div>

            
                
              <Table border :columns="fjColums_v2" :data="fwImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'房屋原貌')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'房屋原貌')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'房屋原貌')">删除</div>
                    </div>
                  </template> 
                </Table>

            <Alert>授权委托书</Alert>   

            <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, '授权委托书')" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="sqhtsImgList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'授权委托书')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'授权委托书')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'授权委托书')">删除</div>
                    </div>
                  </template> 
                </Table>


              
            </VuePerfectScrollbar>
       
             <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='合同终止'"> 
             <div class="base-modal-line">
              <div class="item_1"> <div class="item_1-title">业务状态</div> <div class="item_1-value">{{ houseDetail['业务状态'] }}</div></div>
              <div class="item_1"> <div class="item_1-title">合同状态</div> <div class="item_1-value">{{ houseDetail['合同状态'] }}</div></div>
             </div>
             <div class="base-modal-line">
              <div class="item_1"> <div class="item_1-title">中止原因</div> <div class="item_1-value">{{ houseDetail['中止原因'] }}</div></div>
              <div class="item_1"> <div class="item_1-title">收房违约收入</div> <div class="item_1-value">{{ houseDetail['收房违约收入'] }}</div></div>
             </div>
             <div class="base-modal-line">
              <div class="item_1"> <div class="item_1-title">合同中止时间</div> <div class="item_1-value">{{ houseDetail['合同中止时间'] }}</div></div>
              <div class="item_1"> <div class="item_1-title">中止日期</div> <div class="item_1-value">{{ houseDetail['中止日期'] }}</div></div>
             </div>
                 <Form :model="htzz" ref="htzzForm" :label-width="150" :rules="htzzRuleValidate" style="margin-top:20px;">
                 
                 <Row>
                <Col span="12">
                  <FormItem label="终止原因" >
                      <Select v-model="htzz.zzyy" placeholder="请选择...">
                          <Option v-for="item in ['到期','违约']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                
              </Row>
              <Row v-if="htzz.zzyy=='违约'">
                <Col span="12">
                  <FormItem label="收房违约收入" >
                    <Input v-model="htzz.sfwysr" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="中止日期" >
                    <DatePicker format="yyyy-MM-dd" @onChange="changeZzrq" type="date" placeholder="请选择" style="width: 400px" />
                  </FormItem>
                </Col> 
                
              </Row>

             
                 </Form>
                 <Row> 
                <Col span="20">   </Col>
                <Col span="4"><Button type="info"  @click="hhzzSubmit('htzzForm')" style="width:200px;" :disabled="houseDetail['中止原因']==htzz.zzyy">提交</Button>  </Col>
              </Row>
             </VuePerfectScrollbar>

              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='报修'"> 

              <Form :model="bx" ref="bxForm" :label-width="150" :rules="bxRuleValidate"   style="margin-top:20px;">
                 
                 <Row>
                <Col span="12">
                  <FormItem label="房屋地址" >
                    <Input v-model="houseDetail['房屋地址']"  placeholder="暂无信息" :disabled="true"></Input>
                  </FormItem>
                </Col> 
                
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="报修人" prop="repairPerson" >
                    <Input v-model="bx.repairPerson" placeholder="暂无"  ></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="报修人联系电话" prop="repairPersonContact">
                    <Input v-model="bx.repairPersonContact" placeholder="暂无"  ></Input>
                  </FormItem>
                </Col> 
               
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="房屋情况描述"  prop="houseDescription">
                    <Input v-model="bx.houseDescription" type="textarea" :rows="4" placeholder="请输入..." ></Input>
                  </FormItem>
                </Col> 
                 
               
              </Row>
                 </Form>
                 <Alert>损坏附件情况</Alert>   
            <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'shfjList')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>

                  <Table border :columns="fjColums" :data="shfjList" :max-height="400"> 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="'/xjby/view/'+row.save_name" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'shfjList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'shfjList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteshfj(index)">删除</div>
                      </div>
                    </template> 
                  </Table>
                 <Row> 
                <Col span="20">   </Col>
                <Col span="4"><Button type="info"  @click="bxSubmit('bxForm')" style="width:200px;" >提交</Button>  </Col>
              </Row>
              
              </VuePerfectScrollbar>
              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='查看空置记录'">
         
                <div class="box-1-2">
                
                <div style="width: 100%;">
                  <Table border :columns="kzColumn" :data="recordList" style="height:100%;">  
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchRecordDetail(row)">详情</div> 
                    </div>
                  </template> 
                </Table>
                  </div>
                  <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.55+'px' ,'overflow':'auto','padding':'10px'}"> 
                    <div class="base-modal-line" v-for="key in kzKey" :key="key">
                      <div class="item_3"> <div class="item_3-title">{{ key }}</div> <div class="item_3-value">{{ detailRecord[key] }}</div></div>
                      
                    </div>
                   
              
                </VuePerfectScrollbar>
                 
              </div>
              </VuePerfectScrollbar>
              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='查看出租记录'">
            
                <div class="box-1-2">
                
                <div style="width: 100%;">
                  <Table border :columns="kzColumn" :data="recordList" style="height:100%;">  
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchRecordDetail(row)">详情</div> 
                    </div>
                  </template> 
                </Table>
                  </div>
                  <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.55+'px' ,'overflow':'auto','padding':'10px'}"> 
                    <div class="base-modal-line" v-for="key in czKey" :key="key">
                      <div class="item_3"> <div class="item_3-title">{{ key }}</div> <div class="item_3-value">{{ detailRecord[key] }}</div></div>
                      
                    </div>
                    <Alert>身份证信息</Alert>   
                      <div v-if="ccjlSfzList==0">暂无照片</div>
                      <div style="display: flex;gap:30px;  flex-wrap: wrap;" v-else>
                        <el-image   v-for="(item,index) in ccjlSfzList"  :key="item" 
                        style="width: 200px; height: 200px"
                        :src="ccjlSfzList[index]" 
                        :preview-src-list="ccjlSfzList">
                      </el-image>
                      </div>  

                      <Alert>租房合同信息</Alert>   
                      <div v-if="ccjlHtList==0">暂无照片</div>
                      <div style="display: flex;gap:30px; flex-wrap: wrap;  " v-else>
                        <el-image   v-for="(item,index) in ccjlHtList"  :key="item" 
                        style="width: 200px; height: 200px"
                        :src="ccjlHtList[index]" 
                        :preview-src-list="ccjlHtList">
                      </el-image>
                      </div>  
              
                </VuePerfectScrollbar>
                 
              </div>
              </VuePerfectScrollbar>

              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='更改为自用房'">
                <div class="base-modal-line">
                  <div class="item_1"> <div class="item_1-title">当前业务状态</div> <div class="item_1-value">{{ houseDetail['业务状态'] }}</div></div> 
                </div>
                <div class="base-modal-line" style="margin-top:150px;padding-right:200px;justify-content: flex-end;">
                  <Button type="info"  @click="changeZyf()" style="width:200px;"  :disabled="houseDetail['业务状态']=='自用房'">{{ houseDetail['业务状态']=='自用房'?"已经是自用房，无需修改":'确认修改' }}</Button> 
                </div>

              </VuePerfectScrollbar>
              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='续约'">
            
                <div class="base-modal-line" style="margin-top:150px;">
                  <Button type="info"  @click="operateXy()" style="width:200px;"  >立即续约</Button> 
                </div>

              </VuePerfectScrollbar>
              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='更改为待出租'">
                <div class="base-modal-line">
                  <div class="item_1"> <div class="item_1-title">当前业务状态</div> <div class="item_1-value">{{ houseDetail['业务状态'] }}</div></div> 
                </div>
                <div class="base-modal-line" style="margin-top:150px;padding-right:200px;justify-content: flex-end;">
                  <Button type="info"  @click="changeDcz()" style="width:200px;"  :disabled="houseDetail['业务状态']=='待出租'">{{ houseDetail['业务状态']=='待出租'?"已经是待出租，无需修改":'确认修改' }}</Button> 
                </div>

              </VuePerfectScrollbar>

              <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='补充信息'">
                <Alert type="warning" show-icon closable>温馨提示:未提交前请勿刷新页面，否则会丢失填入的数据和附件。</Alert>   
                <Form :model="house" ref="otherInfoForm" :label-width="150" :rules="ruleValidate">
              
                <Row>
                  <Col span="12">
                    <FormItem label="产权人身份证号">
                      <Input v-model="houseDetail['产权人身份证号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="房源类型">
                      <Select v-model="houseDetail['房源类型']" placeholder="请选择...">
                        <Option v-for="item in ['集中式','分散式']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="不动产单元号">
                      <Input v-model="houseDetail['不动产单元号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="出租用途">
                      <Select v-model="houseDetail['出租用途']" placeholder="请选择...">
                        <Option v-for="item in ['居住','办公','商业','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="出租部位">
                      <Select v-model="houseDetail['出租部位']" placeholder="请选择...">
                        <Option v-for="item in ['整套','东卧','南卧','西卧','北卧','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="出租方式">
                      <Select v-model="houseDetail['出租方式']" placeholder="请选择...">
                        <Option v-for="item in ['整租','分组']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="临街状态">
                      <Select v-model="houseDetail['临街状态']" placeholder="请选择...">
                        <Option v-for="item in ['临街','不临街']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="装修标准">
                      <Select v-model="houseDetail['装修标准']" placeholder="请选择...">
                        <Option v-for="item in ['精装','简装','毛坯']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="产权性质">
                      <Select v-model="houseDetail['产权性质']" placeholder="请选择...">
                        <Option v-for="item in ['私有房产','单位房产','公房','涉外房产','其他房产']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="室号">
                      <Input v-model="houseDetail['室号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="坐落">
                      <Input v-model="houseDetail['坐落']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="公示坐落">
                      <Input v-model="houseDetail['公示坐落']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="街道办">
                      <Input v-model="houseDetail['街道办']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="路街巷">
                      <Input v-model="houseDetail['路街巷']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="院门牌号">
                      <Input v-model="houseDetail['院门牌号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="建成年代">
                      <Input v-model="houseDetail['建成年代']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="房源分类">
                      <Select v-model="houseDetail['房源分类']" placeholder="请选择...">
                        <Option v-for="item in ['单位转租','单位直租','委托代理出租']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="出租间套数">
                      <InputNumber  v-model="houseDetail['出租间套数']"  placeholder="请输入..." /> 
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="权属证明编号">
                      <Input v-model="houseDetail['权属证明编号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="权属证明名称">
                      <InputNumber  v-model="houseDetail['权属证明名称']"  placeholder="请输入..." /> 
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="楼号">
                      <Input v-model="houseDetail['楼号']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="套内建筑面积">
                      <InputNumber  v-model="houseDetail['套内建筑面积']"  placeholder="请输入..." /> 
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="厨">
                      <Input v-model="houseDetail['厨']"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                   <Col span="12">
                    <FormItem label="是否可同步">
                      <RadioGroup v-model="houseDetail['是否可同步']">
                        <Radio label="是">  <span>是</span> </Radio>         <Radio label="否">  <span>否</span> </Radio> 
                      </RadioGroup>
                    </FormItem> 
                   </Col> 
                </Row>
                <Row>
                  <Col span="24">
                    <FormItem label="说明">
                      <Input v-model="houseDetail['说明']" type="textarea" :rows="4"  placeholder="请输入..."></Input>
                    </FormItem> 
                   </Col>
                 
                </Row>
                <Row>
                  <Col span="20">
                    
                   </Col>
                   <Col span="4">
                    <Button style="width:200px;" type="primary" @click="updateOtherInfo('otherInfoForm')">新增</Button>
                  </Col>
                </Row>
  
              </Form>
              </VuePerfectScrollbar>

            
          
          </div>
          <template #footer>
                <div></div> 
            </template>
    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import RecursiveRenderer from '../line/line.vue';
import otherInfo from './components/other_info.vue'
import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx"; 
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {utilTools} from "@/utils/js/utilTools.js" 
import {fileMethod} from "@/api/files/fileMethod";
 
export default { 
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar,RecursiveRenderer,otherInfo},
  props:{
    houseDetail:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          otherModal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant","data_field_map","_index","_rowKey","create_user",],
          illustrate:  {} ,//按钮说明
          //  {name:"补充信息",content:"补充其他信息。"}
          illustrateList:[
            {name:"修改附件",content:"修改房源的附件信息，如房源照片，身份证信息，房屋托管合同信息，产证信息，委托授权书等"},
            {name:"合同终止",content:"终止此房源合同，请注意是否需要收取违约金，检查房间等。"},
            {name:"报修",content:"针对房间电器，家具损坏的流程。"},
            {name:"查看空置记录",content:"查看空置记录等"},
            {name:"查看出租记录",content:"查看出租记录等"},
            {name:"更改为自用房",content:"更改用途自用房"},
            {name:"续约",content:"进行续约操作，请确认续约时间和缴费时间。"},
            {name:"更改为待出租",content:"更改为可出租状态"},
            {name:"补充信息",content:"补充其他信息。"},
          ],
          // 照片表格
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 房间照片表格
          fjColums_v2:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '房间', key: 'type_2', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 空置
          kzColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '房源地址', key: '房源地址', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '空置天数', key: '空置天数', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
            // 出租
            cczColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '合同编号', key: '合同编号', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '出房租金（元/月）', key: '出房租金', align: 'center'},
            {title: '业务状态', key: '业务状态', align: 'center'},
            {title: '出房人', key: '出房人', align: 'center'},
            {title: '出房门店', key: '出房门店', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
          houseDetailShow:{},
          czImgList:[],//
          sfzImgList:[],
          fwtghtImgList:[],
          sqhtsImgList:[],
          fwImgList:[],

          // ktImgList:[],
          // cfImgList:[],
          // wsImgList:[],
          // wsjImgList:[],
          // qtImgList:[],
          //合同中止相关参数
          htzz:{
            zzyy:"",//中止原因：到期，违约
            sfwysr:0,//收房违约收入
            zzrq:""//中止日期
          },
          htzzRuleValidate:{
            // zzyy: [ { required: true, message: '中止原因不能为空', trigger: 'change' } ], 
          },
          bx:{//报修
            repairPerson:'',repairPersonContact:"",houseDescription:"",
          },
          bxRuleValidate:{
            repairPerson: [ { required: true, message: '报修人不能为空', trigger: 'blur' } ], 
            repairPersonContact: [ { required: true, message: '报修人联系电话不能为空', trigger: 'blur' } ], 
            houseDescription: [ { required: true, message: '房屋情况描述不能为空', trigger: 'blur' } ], 
          },
          shfjList:[],
          recordList:[],//存储空置记录/出租记录
          detailRecord:{},//当前详情
          kzKey:["房源地址",'状态','状态','租房价格','操作时间','合同起始日','合同到期日','空置天数','操作人',],//详情的key
          czKey:["租客姓名","联系电话","开户行","银行卡号","出房人","出房门店","成交差价（元/月）","成交周期（天）","出房渠道","合同编号","合同起始日",
          "合同到期日","出房费用（元）","出房押金（元）","水电气押金","出房租金（元/月）","租金支付周期","物业/宽带费","物业/宽带费支付周期","违约收入","特别约定"],//详情的key
          ccjlSfzList:[],
          ccjlHtList:[]

        }
    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      

  
    },
    created(){  
    


    },
   
    watch:{},
    methods:{
      changeIllustrate(name){
        this.illustrate=this.illustrateList.find((i)=>{return i.name===name})
        if(name==="修改附件"){
          // this.cleanPhotoList_fw("客厅照片")
          // this.cleanPhotoList_fw("卧室照片")
          // this.cleanPhotoList_fw("厨房照片")
          // this.cleanPhotoList_fw("卫生间照片")
          // this.cleanPhotoList_fw("其他照片")

          
          this.cleanPhotoList("房屋原貌")
          this.cleanPhotoList("房屋托管合同信息")
          this.cleanPhotoList("产证信息")
          this.cleanPhotoList("身份证信息")
          this.cleanPhotoList("授权委托书")
        }
        else if(name==="查看空置记录"){
          this.initRecord("查看空置记录")
         
        }
        else if(name==="查看出租记录"){
          this.initRecord("查看出租记录")
          // this.cleanPhotoList("身份证信息")
        
        }

      },
      getPhotoOnlyShow(data,oldSystemKey,father_table,father_id,type1,type2,showDataName){
        console.log("data===",data)
        console.log("data[oldSystemKey]===",data[oldSystemKey])
        let imgList = []
        if(data[oldSystemKey]!=null&&data[oldSystemKey]!=undefined){
          let oldImgList=JSON.parse(data[oldSystemKey])
          oldImgList.forEach((i)=>{
            imgList.push(this.imgBaseUrl+i.fileAddress)
          })
        }
        let params={
          father_table:father_table,
          father_id:father_id,
          type_1:type1,
          type_2:type2
        }
        fileMethod.selectFiles(params).then((res)=>{
          res.data.selectRes.forEach((i)=>{
            imgList.push("/xjby/view/"+i.show_path)
          })
          console.log("imgList==",imgList)
          this[showDataName] = imgList;
        })
    
         

      },
      cleanData(obj, properties) { 
        // console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
      // 查看空置/出租记录
      initRecord(type){
        console.log("id==",this.houseDetail["房源ID"])
        zfglMethod_2_001.selectKzzjRecord({id:this.houseDetail["房源ID"]}).then((res)=>{
          this.recordList=type=="查看空置记录"?res.data.kz:res.data.cz
        })

      },
      // 查看详情
      watchRecordDetail(row){
        this.recordKeyList = Object.keys(row).filter(key => !this.keyNotShow.includes(key));
        this.detailRecord=row
        this.getPhotoOnlyShow(row,"身份证信息","1_出房管理",this.houseDetail.id,"身份证信息",null,"ccjlSfzList")
        this.getPhotoOnlyShow(row,"文件","1_出房管理",this.houseDetail.id,"租房合同信息",null,"ccjlHtList")
      },
      // 清洗照片
         cleanPhotoList(key){ 
          if(this.houseDetail.source==="new_system"){
            let data = this.houseDetail[key];
            zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key,}).then((res)=>{
              console.log(key,"--查询结果--",res)
              let data = res.data
              this.getPhotoList_newSystem(key,data)
            }) 
          }else{
            if (!this.houseDetail[key]) {
              this.saveImage(key,[])
            }
            
            let data = JSON.parse(this.houseDetail[key]);
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return  this.getPhotoList_oldSystem(key,data)
          } 
         },
        //房屋照片特例
       async   cleanPhotoList_fw(key) {
          if (this.houseDetail.source === "new_system") {
            try {
              const res = await zfglMethod_2_001.getHousePhotosById({ id: this.houseDetail.id, type_1: "房屋原貌", type_2: key });
              console.log("图片详情res===", res.data.list);
              
              let imgList = [];
              if (res.data && res.data.list.length > 0) {
                res.data.list.forEach((i) => {
                  let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
                });
              }
              console.log("imgList===", imgList);
              this.saveImage(key,imgList)
              
            } catch (error) {
              this.saveImage(key,imgList)
            }
          } else {
            if (!this.houseDetail['房屋原貌']) {
              this.saveImage(key,[])
            }

            let data = JSON.parse(this.houseDetail['房屋原貌']);
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return this.getPhotoList_oldSystem(key, data);
          }
        },

//旧系统获取图片
        getPhotoList_oldSystem(key,data){
          let imgList = [];
          
          for (const obj of data) {
            if (obj.bz === "new_system") {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.show_path,
                    
                  }
                  imgList.push(tempObj);
              
              // imgList.push("http://localhost:8080/xjby/view/"+obj.show_url);
            } else {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.fileAddress
                  }
                  imgList.push(tempObj);
              // imgList.push(this.imgBaseUrl + obj.fileAddress);
            }
          }
          console.log("imgList==",imgList) 
          this.saveImage(key,imgList)
        },
//新系统获取图片
        getPhotoList_newSystem(key,data){
          let imgList = [];
          zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key}).then((res)=>{
           if(res.data!=null&&res.data.list.length>0){
            res.data.list.forEach((i)=>{
              let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
              // imgList.push("http://localhost:8080/xjby/view/"+i.show_path);
            })
           }
           this.saveImage(key,imgList)
          })
          
        }, 
        
        // 存放照片
        saveImage(key,data){
      
          if(key==="房屋原貌"){ this.fwImgList=data }
          // else if(key==="卧室照片"){ this.wsImgList=data }
          // else if(key==="厨房照片"){ this.cfImgList=data }
          // else if(key==="卫生间照片"){ this.wsjImgList=data }
          // else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data;  }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 

        },
        getImage(key){
          if(key==="房屋原貌"){return this.fwImgList ;}
          // else if(key==="卧室照片"){ return this.wsImgList ; }
          // else if(key==="厨房照片"){ return this.cfImgList ; }
          // else if(key==="卫生间照片"){ return this.wsjImgList ; }
          // else if(key==="其他照片"){ return this.qtImgList ; }

          else if(key==="房屋托管合同信息"){ return this.fwtghtImgList ;  }
          else if(key==="产证信息"){  return this.czImgList ; }
          else if(key==="身份证信息"){ return this.sfzImgList ;  }
          else if(key==="授权委托书"){ return this.sqhtsImgList ;  } 
          else{
            return [];
          }
        },
         // 房屋文件上传
      async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        

        try { 
          let obj = {
          save_name: response.data.saveName,
          save_path: response.data.savePath,
          show_name: response.data.showName,
          show_path: response.data.showPath,
          suffix: response.data.suffix,
          type_1:name,
          type_2:imageType?imageType:null,
          bz:"new_system", 
          father_table:"1_房源",
          father_id:this.houseDetail.id
        };
        let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" +  response.data.saveName, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          zfglMethod_2_001.insertFileRecord(obj).then((res)=>{
            if (name === "产证信息") {
              // this.czImgList.push(obj);
              this.cleanPhotoList("产证信息")
            }
            else if(name === "身份证信息") {
              // this.sfzImgList.push(obj);
              this.cleanPhotoList("身份证信息")
            }
            else if(name === "房屋托管合同信息") {
              // this.fwtghtImgList.push(obj);
              this.cleanPhotoList("房屋托管合同信息")
            }
            else if(name === "房屋原貌") {
              this.cleanPhotoList("房屋原貌")
              // this.fwImgList.push(obj);
              // this.cleanPhotoList_fw("客厅照片")
              // this.cleanPhotoList_fw("卧室照片")
              // this.cleanPhotoList_fw("厨房照片")
              // this.cleanPhotoList_fw("卫生间照片")
              // this.cleanPhotoList_fw("其他照片")

            }
            else if(name === "授权委托书") {
              // this.sqhtsImgList.push(obj);
              this.cleanPhotoList("授权委托书")
            }
            else if(name === "shfjList") {
              this.shfjList.push(obj); 
            }
            else{
              
            }
          })
  
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
          // 在线预览文件
          watchFile(row,name) { 
        utilTools.downloadFromUrl(row.img, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
          utilTools.downloadFromUrl( row.img, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除预上传的附件 
      deleteFileBefore(row,name) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          zfglMethod_2_001.deleteRecord({id:row.id}).then((res)=>{
            if(res.data.deleteRes===1){
              _this.$Message.success("删除成功")
              this.cleanPhotoList(name)
            }
          })

        }
      })
      },
      // 合同终止提交
      hhzzSubmit(name) {
        let _this = this;
        let param = _this.htzz;
        if(param.zzyy==""||param.zzyy==null){
          this.$Message.error("请选择中止原因")
          return;
        }else{
          param.id = _this.houseDetail.id;
       
              this.$Modal.confirm({
                title: '确认提交提醒',
                content: `<br>请核实您输入的信息<br>`,
                onOk() {
                

                  zfglMethod_2_001.hhzzOperate(param).then((res) => {
                    console.log("合同中止t——res====", res);
                    if(res.data.updateRes!=0 && res.data.updateRes!=null){
                      _this.$Message.success("合同终止成功！")
                       _this.otherModal=false
                    }
                  });
                }
              });
        }
       
        // this.$refs[name].validate().then((valid) => {
        //   console.log("valid==", valid);
        //   if (valid) {
        //     let _this = this;
        //     this.$Modal.confirm({
        //       title: '确认提交提醒',
        //       content: `<br>请核实您输入的信息<br>`,
        //       onOk() {
        //         let param = _this.htzz;
        //         param.id = _this.houseDetail.id;

        //         zfglMethod_2_001.hhzzOperate(param).then((res) => {
        //           console.log("合同中止t——res====", res);
        //           // if(res.data.insertRes!=0 && res.data.insertRes!=null){
        //           //   _this.$Message.success("新增成功！")
        //           //   _this.modal=false
        //           // }
        //         });
        //       }
        //     });
        //   } else {
        //     this.$Message.error('请核实输入的内容!');
        //   }
        // }).catch((error) => {
        //   console.error("Validation error:", error);
        // }).finally((final) => {
        //   console.log("Validation completed.",final);
        //   // 在此处执行任何需要在验证完成后执行的操作
        // });
      },
      //报修提交
      bxSubmit(name) {

        this.$refs[name].validate((valid) => {
         if (valid) {
            // this.$Message.success('Success!'); 
            let _this=this
            this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                let param=_this.houseDetail
               
                param.repairPerson=_this.bx.repairPerson
                param.repairPersonContact=_this.bx.repairPersonContact
                param.houseDescription=_this.bx.houseDescription
              
                param.damageAttachment=JSON.stringify(_this.shfjList)
                 
                console.log("预提交===》",param)
                smwxMethod_9_001.insertRecord(param).then((res)=>{
                  console.log("报修提交——res====",res)
                  if(res.data.insertRes!=0 && res.data.insertRes!=null){
                    _this.$Message.success("报修记录添加成功！")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }
                })


              }})
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
       
       
      
      },
      // 更改为自用房
      changeZyf(){
        let _this=this
            this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>提交后不可撤回<br>`,
              onOk(){
                let param={
                  id:_this.houseDetail.id
                }
                 
                console.log("更改为自用房-预提交===》",param)
                zfglMethod_2_001.changeUseBySelf(param).then((res)=>{
                  console.log("报修提交——res====",res)
                  if(res.data.updateRes!=0 && res.data.updateRes!=null){
                    _this.$Message.success("成功修改为自用房！")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }
                })


              }})
      },
      // operateXy续约
      operateXy(){
        let _this=this
            this.$Modal.confirm({
              title: '确认续约提醒',
              content: `<br>请注意，点击确认后不可撤回！<br>`,
              onOk(){
                let param={
                  id:_this.houseDetail.id
                }
                 
                console.log("确认续约-预提交===》",param)
                zfglMethod_2_001.operateXy(param).then((res)=>{
                  console.log("报修提交——res====",res)
                  if(res.data.insertRes!=0 && res.data.updateRes!=null){
                    _this.$Message.success("续约成功！新增一条记录！")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }
                })


              }})
      },
      // 更改为待出租
      changeDcz(){
        let _this=this
            this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>提交后不可撤回<br>`,
              onOk(){
                let param={
                  id:_this.houseDetail.id
                }
                 
                console.log("更改为待出租-预提交===》",param)
                zfglMethod_2_001.changeUseByHire(param).then((res)=>{
                  console.log("报修提交——res====",res)
                  if(res.data.updateRes!=0 && res.data.updateRes!=null){
                    _this.$Message.success("成功修改为待出租！")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }
                })


              }})
      },
      // 删除
      deleteshfj(index){
        this.shfjList.splice(index, 1);
      },
      // 补充其他信息
      updateOtherInfo(name){
        let param=this.houseDetail
        zfglMethod_2_001.updateOtherInfo(param).then((res)=>{
          console.log("updateOtherInfo====",res)
          if(res.data.updateRes!=0 && res.data.updateRes!=null){
            this.$Message.success("修改成功！")
            this.$emit("init")
            this.otherModal=false
          }
        })
      },


        getHeight(value) {
          if (value == null) {
            return 50;
          }

        const processedValue = value.toString().replace(/\s+/g, ',');

          const length = processedValue.length; 
          const lines = Math.ceil(length / 28);
          return lines * 50;
        },
        changeZzrq(date){
        this.htzz.zzrq=date
      },
       
      cancel(){
        this.detailModal=false
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'other_operate_modal.scss'; 

.base-modal{
        width: 100%;
        height: 700px;
        padding: 20px;
        .illustrate{
          width: 100%;
          height: 50px;
          line-height: 50px;
          display: flex;
          gap:20px;
        }
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }
            .item_3{
                width: 100%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_3-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_3-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            

        }
        .box-1-2{
              width:100%;
              height: 100%;
              display: grid;
              grid-template-columns:50%  50%;
              
            }
    }
  </style>